import { Controller } from "@hotwired/stimulus";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import { configureTypeaheadAutocomplete } from "../typeaheadHelper";

export default class CloningController extends Controller {

    static targets = [
        "author",
        "authorUserUniqueId",
        "form",
        "submit"
    ];

    static values = {
        searchUsersUrl: String,
        getJobUrl: String
    };

    readonly authorTargets!: HTMLElement[]; // collection needed - typeahead creates another input
    readonly authorUserUniqueIdTarget!: HTMLElement;
    readonly formTarget!: HTMLElement;
    readonly submitTarget!: HTMLElement;

    readonly searchUsersUrlValue!: string;
    readonly getJobUrlValue!: string;

    connect() {
        this.configureAuthorTypeahead();

        formSubmitWithWaitForJobCompletion(
            $(this.formTarget),
            $(this.submitTarget),
            this.getJobUrlValue,
            () => {
                history.back();
            },
            "Really clone the destination with inherited POIs?"
        );
    }

    private configureAuthorTypeahead() {
        configureTypeaheadAutocomplete(
            this.searchUsersUrlValue,
            $(this.authorTargets),
            $(this.authorUserUniqueIdTarget),
            user => `${user.userName} (${user.userEmail}, ${user.companyName})`,
            "userUniqueId",
            "$searchTerm"
        );
    }

    cancel() {
        history.back();
    }
}
